import React, { useState, useEffect } from 'react';
import axios from 'axios';

const api = axios.create({ baseURL: process.env.REACT_APP_API_URL || 'https://drvivara.cloud/api' });
api.interceptors.request.use(c => { const t = localStorage.getItem('token'); if (t) c.headers.Authorization = `Bearer ${t}`; return c; });

const ReelSubscriptionSettings = () => {
  const [settings, setSettings] = useState({ amount: 999, duration_days: 365, is_active: true });
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [message, setMessage] = useState('');

  useEffect(() => { fetchSettings(); }, []);

  const fetchSettings = async () => {
    try {
      const res = await api.get('/reel-subscription-settings/admin');
      if (res.data.success) setSettings(res.data.data);
    } catch (e) { console.error(e); }
    finally { setLoading(false); }
  };

  const handleSave = async () => {
    setSaving(true);
    setMessage('');
    try {
      const res = await api.put('/reel-subscription-settings/admin', settings);
      if (res.data.success) { setMessage('Settings saved successfully!'); setSettings(res.data.data); }
    } catch (e) { setMessage('Failed to save settings'); }
    finally { setSaving(false); }
  };

  return (
    <div className="p-6 max-w-2xl mx-auto">
            <div className="bg-white rounded-xl shadow-sm border p-6">
              <h2 className="text-xl font-semibold mb-1">Reels Creator Membership</h2>
              <p className="text-sm text-gray-500 mb-6">Configure the subscription pricing that creators see when they want to upload reels.</p>

              {message && (
                <div className={`p-3 rounded-lg mb-4 text-sm ${message.includes('success') ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'}`}>
                  {message}
                </div>
              )}

              {loading ? (
                <div className="text-center py-8 text-gray-400">Loading...</div>
              ) : (
                <div className="space-y-5">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Price (₹)</label>
                    <input type="number" value={settings.amount}
                      onChange={e => setSettings({ ...settings, amount: parseInt(e.target.value) || 0 })}
                      className="w-full border rounded-lg px-3 py-2 text-lg font-semibold" min="0" />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Duration (days)</label>
                    <input type="number" value={settings.duration_days}
                      onChange={e => setSettings({ ...settings, duration_days: parseInt(e.target.value) || 30 })}
                      className="w-full border rounded-lg px-3 py-2" min="1" />
                    <p className="text-xs text-gray-400 mt-1">e.g. 365 = 1 year, 30 = 1 month</p>
                  </div>
                  <div className="flex items-center gap-3">
                    <input type="checkbox" id="is_active" checked={settings.is_active}
                      onChange={e => setSettings({ ...settings, is_active: e.target.checked })}
                      className="w-4 h-4" />
                    <label htmlFor="is_active" className="text-sm font-medium text-gray-700">Active (subscription can be purchased)</label>
                  </div>

                  <div className="bg-gray-50 rounded-lg p-4 border">
                    <p className="text-sm font-medium text-gray-700 mb-2">Preview (what creators see):</p>
                    <div className="bg-gray-900 rounded-lg p-4 text-center max-w-xs mx-auto">
                      <p className="text-gray-400 text-sm mb-2">Reels Creator Subscription</p>
                      <p className="text-2xl font-bold text-gold mb-1">₹{settings.amount}</p>
                      <p className="text-xs text-gray-500">per {settings.duration_days} days</p>
                      <div className={`mt-3 text-xs ${settings.is_active ? 'text-green-400' : 'text-red-400'}`}>
                        {settings.is_active ? '● Available for purchase' : '● Currently disabled'}
                      </div>
                    </div>
                  </div>

                  <button onClick={handleSave} disabled={saving}
                    className="w-full bg-blue-600 text-white py-3 rounded-lg font-semibold hover:bg-blue-700 disabled:opacity-50">
                    {saving ? 'Saving...' : 'Save Settings'}
                  </button>
                </div>
              )}
            </div>
    </div>
  );
};

export default ReelSubscriptionSettings;
